import { Warning } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { FC } from "react";

const DefaultModal: FC<{
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleClick: (id: string) => void;
  question: string;
  someId?: string;
}> = ({ setShowModal, handleClick, question, someId }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
      className="fixed top-0 left-0 bg-deepBlue/80 backdrop-blur-sm w-full h-screen grid place-items-center p-5 z-50"
    >
      <div className="bg-white max-w-sm w-full p-5 rounded-xl shadow-sm flex items-center flex-col gap-5">
        <div className="p-2 bg-gray-100 rounded-full ring-8 ring-gray-50">
          <Warning size={28} />
        </div>
        <div className="flex items-center flex-col">
          <p className="text-gray-500 text-center">{question}</p>
        </div>
        <div className="flex items-center gap-5 w-full">
          <button
            type="button"
            aria-label="Cancel"
            onClick={() => setShowModal(false)}
            className="p-3 px-5 flex-1 border-red-100 border-2 rounded-lg font-bold bg-red-50/50 text-red-500 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              handleClick(someId || "");
              setShowModal(false);
            }}
            className="p-3 px-5 flex-1 border-visaro-gray-700 border-2 rounded-lg font-bold bg-deepBlue text-white text-sm"
          >
            Continue
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default DefaultModal;
